import request from '@/http/request'

export const readRfid = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_MAC_URL_PHONE}/rfid`, params, {
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const resetRfid = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_MAC_URL_PHONE}/resetRfid`, params, {
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const demoBind = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-clc-service/nfc/demo/bind`, params, {
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const rfidBind = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/bind`, params, {
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const getOrderByCarton = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/getOrderByCarton`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const validEpc = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/validEpc`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const validUpc = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/validUpc`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const validQrCode = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/validQrCode`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const validateNextCarton = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/validateNextCarton`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const forceFinishCarton = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/forceFinishCarton`,
    {},
    {
      params,
      nfc: true,
      // noSpin: true,
      headers: queryHeader
    }
  )
}

export const getScanInfoByCarton = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/roundCartonScan/getCartonScanInfo`,
    params,
    {
      nfc: true,
      // noSpin: true,
      headers: queryHeader
    }
  )
}

export const getSkuInfoByEpc = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/roundCartonScan/getSkuInfoByEpc`,
    params,
    {
      nfc: true,
      // noSpin: true,
      headers: queryHeader
    }
  )
}

export const getSkuInfoByUpc = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/roundCartonScan/getSkuInfoByUpc`,
    params,
    {
      nfc: true,
      // noSpin: true,
      headers: queryHeader
    }
  )
}

export const getSkuInfoByQRCode = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/roundCartonScan/getSkuInfoByQRCode`,
    params,
    {
      nfc: true,
      // noSpin: true,
      headers: queryHeader
    }
  )
}

export const validQRCodeAndUpc = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/roundCartonScan/validQRCodeAndUpc`,
    params,
    {
      nfc: true,
      // noSpin: true,
      headers: queryHeader
    }
  )
}

export const manualCheckInfoByCarton = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/roundCartonScan/manualCheck`,
    params,
    {
      nfc: true,
      headers: queryHeader
    }
  )
}

export const startRoundScan = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_MAC_URL_PHONE}/startRoundCartonScan`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const stopRoundScan = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_MAC_URL_PHONE}/stopRoundCartonScanEpc`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const getRoundScanResult = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_MAC_URL_PHONE}/getRoundCartonScanEpc`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const manualRoundScanByCarton = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/roundCartonScan/manualRoundCartonScan`,
    params,
    {
      nfc: true,
      headers: queryHeader
    }
  )
}

export const manualScanByPiece = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/roundCartonScan/manualScanByPiece`,
    params,
    {
      nfc: true,
      headers: queryHeader
    }
  )
}

export const manualScanCount = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/roundCartonScan/manualScanCount`,
    params,
    {
      nfc: true,
      headers: queryHeader
    }
  )
}

export const validRelabeledEpc = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/roundCartonScan/validRelabeledEpc`,
    params,
    {
      nfc: true,
      headers: queryHeader
    }
  )
}
